"use strict";
/**
 * This file contains model that have been deprecated and should not be present in the codemodel produced by modelerfour.
 * They are kept here to reduce the breaking changes in generator that don't pin their dependencies.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AzureKeySecurityScheme = exports.AADTokenSecurityScheme = void 0;
/**
 * @deprecated use @see OAuth2SecurityScheme
 */
class AADTokenSecurityScheme {
    constructor(objectInitializer) {
        this.type = "AADToken";
        Object.assign(this, objectInitializer);
    }
}
exports.AADTokenSecurityScheme = AADTokenSecurityScheme;
/**
 * @deprecated use @see OAuth2SecurityScheme
 */
class AzureKeySecurityScheme {
    constructor(objectInitializer) {
        this.type = "AzureKey";
        Object.assign(this, objectInitializer);
    }
}
exports.AzureKeySecurityScheme = AzureKeySecurityScheme;
//# sourceMappingURL=deprecated.js.map